import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const SuppositoryIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 36 36",
  path: (
    <>
      <Path
        d="M15.9511 32.1447H20.1795C21.3786 32.1447 22.3775 31.2296 22.4802 30.0357C22.8736 25.4994 24.047 14.9815 23.6074 11.9402C22.8171 6.45971 19.5 4 18.0363 4C16.5 4 13.086 6.42893 12.1076 11.7623C11.5774 14.6462 13.1527 25.3951 13.6539 30.0802C13.7805 31.2536 14.7709 32.1447 15.9511 32.1447Z"
        fill="none"
        stroke-width="2.2"
        stroke-miterlimit="10"
      />
    </>
  ),
});

SuppositoryIcon.displayName = "SuppositoryIcon";
export { SuppositoryIcon };
